/* ============================================================
   Craft Com — suivi des conversions Google Ads
   Conversion « Contact » : clic WhatsApp (wa.me), e-mail (mailto:),
   téléphone (tel:) et envoi du formulaire de devis (ouvre WhatsApp).
   ============================================================ */
(function () {
  var AW_ID = 'AW-18510379086';
  var CONTACT_LABEL = AW_ID + '/_LEhCMOB05wdEM7wt_pE';

  // gtag : réutilise celui de l'app Google de Shopify s'il existe, sinon le charge.
  window.dataLayer = window.dataLayer || [];
  if (typeof window.gtag !== 'function') {
    window.gtag = function () { window.dataLayer.push(arguments); };
    window.gtag('js', new Date());
  }
  if (!document.querySelector('script[src*="googletagmanager.com/gtag/js?id=' + AW_ID + '"]')) {
    var s = document.createElement('script');
    s.async = true;
    s.src = 'https://www.googletagmanager.com/gtag/js?id=' + AW_ID;
    document.head.appendChild(s);
  }
  window.gtag('config', AW_ID, { send_page_view: false });

  // Anti-doublon : une seule remontée par seconde.
  var last = 0;
  function reportContact(channel) {
    var now = Date.now();
    if (now - last < 1000) return;
    last = now;
    try {
      window.gtag('event', 'conversion', {
        send_to: CONTACT_LABEL,
        value: 1.0,
        currency: 'EUR',
        transport_type: 'beacon',
        event_label: channel
      });
    } catch (e) {}
  }

  function channelOf(url) {
    if (typeof url !== 'string') return null;
    if (/^https?:\/\/(wa\.me|api\.whatsapp\.com|web\.whatsapp\.com)\//i.test(url)) return 'whatsapp';
    if (/^mailto:/i.test(url)) return 'email';
    if (/^tel:/i.test(url)) return 'telephone';
    return null;
  }

  // 1) Clics sur les liens (y compris ceux dont le href est rempli par app.js).
  document.addEventListener('click', function (e) {
    var a = e.target && e.target.closest ? e.target.closest('a[href]') : null;
    if (!a) return;
    var ch = channelOf(a.href);
    if (ch) reportContact(ch);
  }, true);

  // 2) Ouvertures WhatsApp par script (formulaire de devis -> window.open).
  var prevOpen = window.open;
  window.open = function (url) {
    var ch = channelOf(url);
    if (ch) reportContact(ch);
    return prevOpen.apply(window, arguments);
  };
})();
